<template>
  <li
    :class="[
      'el-dropdown-menu__item',
      newDesign && 'el-dropdown-menu__item--new-design',
      disabled && 'is-disabled',
      divided && 'el-dropdown-menu__item--divided',
      icon && 'el-dropdown-menu__item--with-icon',
    ]"
    @click="handleClick"
    :aria-disabled="disabled"
    :tabindex="disabled ? null : -1"
  >
    <i
      :class="['icon ' + 'icon-' + icon]"
      v-if="icon"
    />
    <div class="el-dropdown-menu__content">
      <slot />
    </div>
  </li>
</template>

<script>
import { DropdownItem as ElDropdownItem } from 'element-ui';

export default {
  name: 'DropdownItem',
  // Need fix this
  extends: ElDropdownItem,
  // components: {
  //   ElDropdownItem,
  // },
  props: {
    disabled: Boolean,
    divided: Boolean,
    icon: String,
    command: {
      type: [String, Number, Object, Array, Function],
    },
    newDesign: Boolean,
  },
  methods: {
    handleClick() {
      this.dispatch('ElDropdown', 'menu-item-click', [this.command, this]);
    },
  },
};
</script>

<style lang="scss">
.el-dropdown-menu__item,
.el-dropdown-menu--new-design .el-dropdown-menu__item {
  margin-top: rem(10px);
  margin-bottom: rem(10px);
  padding-left: rem(35px);
  padding-right: rem(35px);
  color: $--color-primary;
  line-height: 1.3;

  &:not(.is-disabled):hover,
  &:hover,
  &:focus {
    background-color: transparent;

    .el-dropdown-menu__content {
      text-decoration: none;
      color: $--color-primary-dark-3;
    }
  }

  .el-dropdown-menu__content {
    text-decoration: underline;
    min-width: 210px;
  }
}

.el-dropdown-menu__item--with-icon {
  position: relative;
  padding-left: rem(50px);

  .icon {
    position: absolute;
    left: rem(20px);
    top: rem(2px);
  }

  &.el-dropdown-menu__item--close {
    display: flex;

    .icon {
      right: 0;
      left: auto;
    }
  }
}

.el-dropdown-menu__item--user {
  padding: 0;
  margin: 0 0 8px;

  .el-dropdown-menu__content {
    text-decoration: none;
    color: $--color-text-regular;
  }
}

.el-dropdown-menu__item--divided {
  margin-bottom: 0;
  border-color: $--color-gray-6;

  &::before {
    content: none;
  }
}

.el-dropdown-menu__item--new-design {
  padding: 6px 12px;
  margin-right: 0;
  margin-left: 0;

  .el-dropdown-menu__content {
    font-size: rem(13px);
    font-weight: 600;
    text-decoration: none;
  }

  @media only screen and (max-width: $--sm - 1px) {
    padding-top: 10px;
    padding-bottom: 10px;

    .el-dropdown-menu__content {
      font-size: rem(16px);
    }
  }

  // TODO: po kompletinm redesignu upravit v samostatne classe (nahore)
  &.el-dropdown-menu__item--with-icon {
    padding-left: 40px;

    .icon {
      font-size: rem(20px);
      left: rem(12px);
      top: 50%;
      transform: translateY(calc(-50% + 1px));
    }

    @media only screen and (max-width: $--sm - 1px) {
      padding-left: 44px;

      .icon {
        font-size: rem(24px);
        margin-right: 8px;
      }
    }
  }

  &.el-dropdown-menu__item--divided {
    border: none;
    margin-top: rem(20px);
    position: relative;

    &::after {
      content: '';
      background-color: $--border-color-base;
      height: 1px;
      left: 0;
      pointer-events: none;
      position: absolute;
      top: -10px;
      width: 100%;
    }
  }
}

</style>
